// 25 payline patterns: each line is an array of [column, row] positions
export const paylines = [
    [[0,1],[1,1],[2,1],[3,1],[4,1]], // 1
    [[0,0],[1,0],[2,0],[3,0],[4,0]], // 2
    [[0,2],[1,2],[2,2],[3,2],[4,2]], // 3
    [[0,0],[1,1],[2,2],[3,1],[4,0]], // 4
    [[0,2],[1,1],[2,0],[3,1],[4,2]], // 5
    [[0,1],[1,2],[2,1],[3,0],[4,1]], // 6
    [[0,1],[1,2],[2,1],[3,2],[4,1]], // 7
    [[0,0],[1,1],[2,0],[3,1],[4,2]], // 8
    [[0,2],[1,1],[2,2],[3,1],[4,0]], // 9
    [[0,2],[1,1],[2,0],[3,1],[4,0]], // 10
    [[0,0],[1,1],[2,0],[3,1],[4,2]], // 11 (same as 8)
    [[0,1],[1,0],[2,1],[3,2],[4,1]], // 12
    [[0,2],[1,1],[2,2],[3,1],[4,2]], // 13
    [[0,1],[1,0],[2,1],[3,0],[4,1]], // 14
    [[0,0],[1,1],[2,0],[3,1],[4,0]], // 15
    [[0,1],[1,1],[2,2],[3,1],[4,1]], // 16
    [[0,0],[1,0],[2,1],[3,0],[4,0]], // 17
    [[0,2],[1,2],[2,1],[3,2],[4,2]], // 18
    [[0,1],[1,1],[2,0],[3,1],[4,1]], // 19
    [[0,0],[1,0],[2,2],[3,0],[4,0]], // 20
    [[0,2],[1,2],[2,0],[3,2],[4,2]], // 21
    [[0,1],[1,1],[2,1],[3,2],[4,1]], // 22
    [[0,0],[1,0],[2,0],[3,1],[4,2]], // 23
    [[0,2],[1,2],[2,2],[3,1],[4,0]], // 24
    [[0,2],[1,1],[2,1],[3,1],[4,0]], // 25
];
